import { JsonObject } from 'type-fest';

export const auth: JsonObject = {};
